(function () {
    angular.module('rightPaneModule')
      .directive("assignedLessonDetails", function () {
          return {
              restrict: "E",
              scope: {
                  assignmentData: '=',
                  showClassroom: '='
              },
              templateUrl: '/resources/right-pane/partials/assigned-lesson-details.html',
              controller: [
                  '$scope',
                  '$timeout',
                  'minutesFilter',
                  'dblLessonService',
                  AssignedLessonDetailsController]
          };
      });

    function AssignedLessonDetailsController(
      $scope,
      $timeout,
      $minutesFilter,
      dblLessonService
    ) {

        $scope.handlePlayDemoLessonClick = handlePlayDemoLessonClick;
        $scope.timeSpentMinutes = timeSpentMinutes;

        function handlePlayDemoLessonClick($event, lesson_slot_id) {
            $event.stopPropagation();
            dblLessonService.openPlayLessonLink(lesson_slot_id);
        }

        function timeSpentMinutes(millis) {
            return $minutesFilter(millis, true);
        }

        $scope.$watch('assignmentData', function () {
            if (_.isArray($scope.assignmentData.student_assignment_histories)) {
                $scope.isSingle = $scope.assignmentData.student_assignment_histories.length === 1;
            }
        }, true);
    }
})();
